// extracted by mini-css-extract-plugin
module.exports = {"poweroceanSinglePhase":"PoweroceanSinglePhase_poweroceanSinglePhase__Oq96o"};